// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"InfiniteScrollLoader__loaderContainer__1tC96"};